import React from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';

const LessonsCreated = function ({days}) {
    const dashboard_stats = useSelector(state => state.dashboard_stats);
    const lessons = dashboard_stats ? dashboard_stats.lessons : [];
    const compileData = function () {
        let data = [];
        if (lessons.length) {
            data.push({
                name: '#classes',
                data: days.map(day => {
                    const lesson = lessons.find(lesson => lesson.created_at === day.toISOString().substring(0, 10));

                    return [
                        day.getTime(),
                        lesson ? lesson.count : 0
                    ];
                })
            });
        }

        return data;
    };

    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={{
                    chart: {
                        type: 'spline'
                    },
                    title: {
                        text: 'Classes created'
                    },
                    xAxis: {
                        title: {
                            text: 'Days'
                        },
                        type: 'datetime'
                    },
                    yAxis: {
                        title: {
                            text: '# classes'
                        }
                    },
                    plotOptions: {
                        area: {
                            pointStart: 0,
                            marker: {
                                enabled: false,
                                symbol: 'circle',
                                radius: 2,
                                states: {
                                    hover: {
                                        enabled: true
                                    }
                                }
                            }
                        }
                    },
                    series: compileData(),
                    credits: {
                        enabled: false
                    },
                    accessibility: {
                        enabled: false
                    }
                }}
            />
        </div>
    );
}

LessonsCreated.propTypes = {
    days: PropTypes.array.isRequired
};

export default LessonsCreated;
